// extracted by css-extract-rspack-plugin
export default {"AppTitleContainer":"AppTitle-module__AppTitleContainer__TKLAWQd","Heading":"AppTitle-module__Heading__DjUOvNL"};